<template>
  <content-dialog
    :visible.sync="modalVisible"
    scrollable
    max-width="500px"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Switch yacht logistics status
    </template>
    <!--</editor-fold>-->

    <v-card-text class="pa-6">
      <v-row

        justify="space-between"
        align="center"
        class="mb-6"
      >
        <v-col
          class="grey--text text--darken-1"
        >
          New Status
        </v-col>
        <v-col class="shrink">
          <v-chip
            :color="statusData.color"
            dark
            class="text-uppercase"
          >
            {{ statusData.label }}
          </v-chip>
        </v-col>
      </v-row>
      <p>
        You are submitting the yacht for approval <strong>before it can be marked as sold</strong>. A representative
        will verify the deal.
      </p>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="updateYacht"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Submit for approval
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
  import Yacht from '@/models/Yacht'
  import ContentDialog from '@/components/helpers/Dialog'

  export default {
    name: 'ApprovalStatusDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        statusData: Yacht.investmentStatusData[Yacht.INVESTMENT_STATUS_APPROVAL],
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      yachtDirty: {
        get: function () {
          return this.yacht
        },
        set: function (value) {
          this.$emit('update:yacht', value)
        }
      }
    },
    methods: {
      async updateYacht() {
        this.submitting = true

        try {
          this.yachtDirty = await Yacht.api.save({ investment_status: this.statusData.key }, this.yachtDirty.id)
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Sales deal submitted for approval.',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>

<style scoped>
</style>
